export default {
	"Coupon.Loading": "正在加载...",
	"Coupon.ClaimSuccessful": "领取成功",
	"Coupon.rise": "起",
	"Coupon.full": "满",
	"Coupon.available": "可用",
	"Coupon.PickUpAgain": "再次领取",
	"Coupon.ClaimItNow": "立即领取",
	"Coupon.Preferential": "优惠",
	"Coupon.MoreCoupons": "更多优惠券"
}